export function init() {
	const siteHeaderWrapper = document.querySelector('.c-site-header-wrapper');
	const headerTrigger = document.querySelector('.js-header-trigger');

	if (siteHeaderWrapper.classList.contains('js-header')) {
		if (headerTrigger) {
			let headerTriggerObserver = new IntersectionObserver((entries) => {
				entries.forEach(entry => {
					if (entry.intersectionRatio <= 0.25) {
						siteHeaderWrapper.classList.remove('is-transparent');
					} else {
						siteHeaderWrapper.classList.add('is-transparent');
					}
				});
			}, { threshold: [0, 0.20, 0.25, 0.30, 1] });
			headerTriggerObserver.observe(headerTrigger);
		}
	}
}
